export default __webpack_public_path__ + "static/media/pattern_1.eeafc8f1.jpg";